<template>
  <b-nav vertical class="sidebar sidebar-panel">
    <b-nav-item
      to="/"
      active-class="active"
      exact
    >Mi cuenta
    </b-nav-item>

    <b-nav-item
      v-if="isAdminOrPartner() && hasMenuPermission('eventos')"
      to="/eventos"
      active-class="active">
      Agenda
    </b-nav-item>

    <b-nav-item
      v-if="isAdminOrPartner()"
      to="/proyectos"
      active-class="active">
      Proyectos
    </b-nav-item>

    <b-nav-item
      v-if="isCustomer()"
      to="/proyectos"
      active-class="active">
      Mis Proyectos
    </b-nav-item>
    <!-- TODO Enable when the function is worked on -->

    <b-nav-item
      v-if="isAdminOrPartner() && hasMenuPermission('pedidos')"
      to="/pedidos"
      active-class="active"
    >
      <template v-if="isPartner()">Sus pedidos</template>
      <template v-else>Pedidos</template>
    </b-nav-item>

    <b-nav-item
      v-if="isAdminOrPartner() && hasMenuPermission('pagos')"
      to="/pagos"
      active-class="active">
      Pagos
    </b-nav-item>

    <b-nav-item
      v-if="isAdminOrPartner() && hasMenuPermission('clientes')"
      to="/clientes"
      active-class="active"
    >
      <template v-if="isPartner()">Sus clientes</template>
      <template v-else>Clientes</template>
    </b-nav-item>

    <b-nav-item v-if="isPartner() && hasMenuPermission('contactos-internos')" to="/contactos" active-class="active">
      Contactos internos
    </b-nav-item>

    <b-nav-item
      v-if="isAdmin()"
      to="/asociados"
      active-class="active"
    >Asociados
    </b-nav-item>

    <b-nav-item
      v-if="isAdmin()"
      to="/proveedores"
      active-class="active"
    >Proveedores
    </b-nav-item>

    <b-nav-item
      v-if="isAdmin()"
      to="/administradores"
      active-class="active"
    >Administradores
    </b-nav-item>

    <b-nav-item
      v-if="isAdmin()"
      to="/packs"
      active-class="active"
    >Promopacks
    </b-nav-item>

    <b-nav-item
      v-if="isAdminOrPartner() && hasMenuPermission('material-de-ventas')"
      to="/material-de-ventas"
      active-class="active"
    >Material de ventas
    </b-nav-item
    >
    <!--<b-nav-item to="/formacion" active-class="active">Formación</b-nav-item>-->
    <!-- TODO Enable when the function is worked on -->
    <b-nav-item
      v-if="hasMenuPermission('noticias')"
      to="/noticias"
      active-class="active"
    >Noticias
    </b-nav-item>

    <b-nav-item v-if="hasMenuPermission('tickets')" to="/tickets" active-class="active">
      Tickets
    </b-nav-item>

    <div class="mt-3"/>

    <b-nav-item
      v-if="isPartner() && getGalleryLink()"
      :href="getGalleryLink()" target="_blank"
    >
      Galería
    </b-nav-item>

    <b-nav-item
      v-if="isPartner()"
      href="https://kuchentime.com/visualizador-tienda" target="_blank"
    >
      Visualizador Tienda
    </b-nav-item>

    <!--<b-nav-item to="/contacto" active-class="active">Contacto</b-nav-item>-->
    <!-- TODO Enable when the function is worked on -->
  </b-nav>
</template>

<script>
import auth from "@/store/authentication.js";

const user_role = auth.state.user_role;
const user_gallery_link = auth.state.gallery_link;
const userMenuPermissions = auth.state.menu_permissions;

export default {
  data() {
    return {
      user: null,
      customers: ["customer"],
      partners: ["partner"],
      admins: ["admin"],
      adminsOrPartners: ["admin", "partner"],
    }
  },
  mounted() {
  },
  methods: {
    isCustomer() {
      return this.$data.customers.includes(user_role);
    },
    isPartner() {
      return this.$data.partners.includes(user_role);
    },
    isAdmin() {
      return this.$data.admins.includes(user_role);
    },
    isAdminOrPartner() {
      return this.$data.adminsOrPartners.includes(user_role);
    },
    hasMenuPermission(permission) {
      // only check partner permissions
      if (!this.isPartner()) {
        return true;
      }

      return userMenuPermissions.includes(permission);
    },
    getGalleryLink() {
      if(!user_gallery_link || user_gallery_link === 'null' || user_gallery_link === ''){
        return null;
      }
      return user_gallery_link;
    }
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue